'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m12.213 4.877 6.827 6.21c.066.06.103.145.103.235v8.48a.317.317 0 0 1-.317.316h-.923v-.633h.607v-8.023L12 5.539l-6.51 5.923v8.023h.606v.633h-.923a.317.317 0 0 1-.316-.316v-8.48c0-.09.037-.174.103-.234l6.827-6.211a.316.316 0 0 1 .426 0Zm-.004-1.798L21 10.814l-.418.475L12 3.74l-8.582 7.55L3 10.814l8.79-7.735a.317.317 0 0 1 .42 0Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.953 11.886c.175 0 .317.142.317.316v7.6a.317.317 0 0 1-.317.316H7.046a.317.317 0 0 1-.316-.316v-7.6c0-.174.142-.316.316-.316Zm-.316 6.333H7.363v1.266h9.274V18.22Zm0-1.9H7.363v1.266h9.274V16.32Zm0-1.9H7.363v1.266h9.274V14.42Zm0-1.9H7.363v1.267h9.274v-1.267Z",
    fill: "currentColor"
  })));
});
var FwSet0Garage = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Garage = FwSet0Garage;